import { render, staticRenderFns } from "./QualityGovernmentPage.vue?vue&type=template&id=3b1ae57e&scoped=true"
import script from "./QualityGovernmentPage.vue?vue&type=script&lang=js"
export * from "./QualityGovernmentPage.vue?vue&type=script&lang=js"
import style0 from "./QualityGovernmentPage.vue?vue&type=style&index=0&id=3b1ae57e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ae57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1ae57e')) {
      api.createRecord('3b1ae57e', component.options)
    } else {
      api.reload('3b1ae57e', component.options)
    }
    module.hot.accept("./QualityGovernmentPage.vue?vue&type=template&id=3b1ae57e&scoped=true", function () {
      api.rerender('3b1ae57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/QualityGovernmentPage.vue"
export default component.exports